















import {
  defineComponent, computed, ref,
} from '@vue/composition-api';
import VueTagsInput from '@johmun/vue-tags-input';

const CommonTagsMultiSelector = defineComponent({
  components: {
    VueTagsInput,
  },
  props: {
    value: {
      type: Array,
      default() { return []; },
    },
    label: {
      type: String,
      default() { return 'Tags'; },
    },
    list: {
      type: Array,
      default() { return []; },
    },
  },
  setup(props: any, context: any) {
    const tag = ref('');
    const tags = computed(() => props.value.map((t: string) => ({ text: t }))); // convert to lib's format
    const computedList = computed(() => props.list.map((t: string) => ({ text: t })));
    const latestLength = ref(0);

    function onTagsUpdated(newTags: { text: string }[]) {
      context.emit('input', newTags.map((objTag) => objTag.text)); // convert back to our format
      if (newTags.length > 0 && newTags.length > latestLength.value) context.emit('newInput', newTags[newTags.length - 1].text);
      latestLength.value = newTags.length;
    }

    return {
      tag,
      tags,
      computedList,
      onTagsUpdated,
    };
  },
});

export default CommonTagsMultiSelector;
